exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projects .card.small {\n  height: 213px !important; }\n\n.projects a {\n  color: #000000; }\n\n.projects .card-action a {\n  text-align: center;\n  color: #ffffff;\n  margin-right: 2px;\n  margin-bottom: 2px; }\n\n.projects .card-title {\n  font-weight: bold !important;\n  margin-bottom: 7px !important; }\n\n.card .card-content {\n  padding: 16px 24px; }\n\n.project-info {\n  margin-bottom: 12px !important; }\n\n.import-export-link {\n  float: right;\n  color: #9c9b99;\n  margin-top: 5px;\n  margin-right: 15px;\n  position: relative; }\n\n.import-export-link:hover {\n  color: #76797E; }\n\n.import-export-link-icon {\n  font-size: 20px;\n  margin-top: 10px;\n  margin-right: 9px; }\n\n.unsynced_changes {\n  color: #cb6f67;\n  font-size: 16px;\n  position: absolute;\n  top: -4px;\n  left: 13px; }\n\n.project-info {\n  margin-bottom: 12px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/sprint-card/sprint-card.component.scss
// module id = ../../../../../src/app/components/sprint-card/sprint-card.component.scss
// module chunks = main